<footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
    <div class="col-md-6 d-flex align-items-center">
        <a href="https://www.megabus.com.au/" class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
            <img id="footer-logo" src="logo-blue.svg" alt="2025 Megabus Software" height="20" />
        </a>
        <span class="mb-3 mb-md-0 text-body-secondary">© 2025 Megabus Software</span>
    </div>

    <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
        <li class="ms-3">
            <a class="text-body-secondary" href="https://www.megabus.com.au/blog"><i class="bi bi-journal-text"></i></a>
        </li>
        <li class="ms-3">
            <a class="text-body-secondary" href="https://www.instagram.com/megabus_software/">
                <i class="bi bi-instagram"></i>
            </a>
        </li>
        <li class="ms-3">
            <a class="text-body-secondary" href="https://www.facebook.com/megabussoftware#">
                <i class="bi bi-facebook"></i>
            </a>
        </li>
        <li class="ms-3">
            <a class="text-body-secondary" href="https://www.linkedin.com/company/megabus/posts/?feedView=all">
                <i class="bi bi-linkedin"></i>
            </a>
        </li>
    </ul>
</footer>
